import React from 'react';
import { hot } from 'react-hot-loader';
import s from './Select.scss';

const Select = ({ variantClasses = [], id, options, selected, inputChange, disabledKey = 'disabled', inputBlur = () => {}, isError = false, label = null, fill = null, inFooter = null, navigation = false }) => {
	const inputChangeHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputChange($input.id, $input.value);
	};

	const inputBlurHandlar = (e) => {
		e.preventDefault();
		const $input = e.currentTarget;
		inputBlur($input.id, $input.value);
	};

	const selectClasses = [s.select, s[`select__${id}`]];
	const labelClasses = [s.label];

	if (!Array.isArray(variantClasses)) variantClasses = [String(variantClasses)];
	variantClasses.filter((c) => !!c).forEach((c) => {
		if (c.indexOf('label') !== -1) labelClasses.push(s[c]);
		else selectClasses.push(s[c]);
	});

	if (inFooter) selectClasses.push(s.select__inFooter);
	if (isError === true) {
		selectClasses.push(s.select__error);
		labelClasses.push(s.label__error);
	}

	label = label || null;
	fill = fill || 'black';

	const select = (
		<div className={selectClasses.join(' ')}>
			{ navigation && <span className={s.select_measureStyles}>{ options.filter((o) => o.key === selected)?.[0]?.value }</span> }
			<select name={id} id={id} onChange={inputChangeHandlar} onBlur={inputBlurHandlar} value={selected}>
				{
					options.map((option) => (typeof option === 'object' ? <option key={option.key} value={option.key} disabled={option[disabledKey] ? true : null}>{(inFooter && option.key === selected ? 'Shipping to' : null)} {option.value}</option> : <option key={option} value={option}>{option}</option>))
				}
			</select>
			{
				inFooter && !navigation && (
					<span>
						<svg className={s.select__lgScreen} width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 9.5L6 1L11.5 9.5" stroke="white" strokeWidth="0.5" />
						</svg>
						<svg className={s.select__smScreen} width="6" height="5" viewBox="0 0 6 5" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M3 3.77783L0.401925 0.0278316L5.59808 0.027832L3 3.77783Z" fill="white" />
						</svg>
					</span>
				)
			}
			{
				!inFooter && !navigation && (
					<svg width="6" height="4" viewBox="0 0 6 4" xmlns="http://www.w3.org/2000/svg"><path d="M3 3.77783L0.401925 0.0278316L5.59808 0.027832L3 3.77783Z" fill={fill} /></svg>
				)
			}
		</div>
	);

	return (
		label ? (
			<label className={labelClasses.join(' ')} htmlFor={id}>
				<span className={s.label_title}>{ label }</span>
				{ select }
			</label>
		) : (
			<div>
				{ select }
			</div>
		)
	);
};

export default hot(module)(Select);
